import actions from './actions';

const {
  GET_DATA_BRANCH,
  SET_DATA_BRANCH,
  DELETE_DATA_BRANCH,
  EDIT_DATA_BRANCH,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  //NEW
  SET_NEW_DATA_BRANCH,
} = actions;

const initialState = {
  data: [],
  total: 0,
  loading: false,
};

const branchsReducer = (state = initialState, action:any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_BRANCH:
      return {
        ...state
      };
    case SET_DATA_BRANCH:
      return {
        ...state,
        data: data.results,
        total: data.totalResults,
        loading: false,
      };
    case DELETE_DATA_BRANCH:
      return {
        ...state,
        data: [...state.data.filter((person:any) => person.id !== data.id)]
      };
    case EDIT_DATA_BRANCH:
      const index = state.data.findIndex((person:any) => person.id === data.id);
      let newArray:any = [...state.data];
      newArray[index] = data;
      return {
        ...state,
        data: newArray
      };
    case SET_NEW_DATA_BRANCH:
      return {
        ...state,
        data: [data, ...state.data],
      };
    case GET_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FINISH:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
export { branchsReducer };
